
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UilabMatFormFieldModule } from '@uilab/ng-mat-components';
import { UilabBaseComponentsModule } from '@uilab/base-components-angular';

@Component({
    selector: 'ui-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    imports: [UilabMatFormFieldModule, UilabBaseComponentsModule],
})
export class SearchUiComponent {
    @Input() hasContent = false;
    @Output() clearSearch = new EventEmitter();

    resetForm() {
        this.clearSearch.emit();
    }
}
